import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ProcessTemplateListItemType } from '@econtractor/types';
import ESpinner from 'components/others/Spinner';
import ProcessDirTable from '../ProcessDir/ProcessDirTable';
import { ProcessCategoryFilterSelect } from '../ProcessDir/ProcessCategory/ProcessCategoryFilter';

interface ProcessTemplatePickerProps {
    searchInput: string;
    setSearchInput: (value: string) => void;
    categoryId: number | null;
    setFilterCategoryId: (categoryId: number | null) => void;
    templates: ProcessTemplateListItemType[] | null;
    showSpinner: boolean;
    onSelect: (template: ProcessTemplateListItemType) => void;
}

const ProcessTemplatePicker = ({
    searchInput,
    setSearchInput,
    categoryId,
    setFilterCategoryId,
    templates,
    showSpinner,
    onSelect,
}: ProcessTemplatePickerProps) => {
    const { t } = useTranslation('Tasks');

    return (
        <>
            <Form.Control
                className="mb-3"
                value={searchInput}
                placeholder={t('directory.search')}
                onChange={(e) => setSearchInput(e.target.value)}
            />
            <div className="mb-3">
                <ProcessCategoryFilterSelect
                    filterCategoryId={categoryId}
                    setFilterCategoryId={setFilterCategoryId}
                />
            </div>
            {templates == null ? (
                <ESpinner />
            ) : (
                <ProcessDirTable templates={templates} showSpinner={showSpinner} onSelect={onSelect} />
            )}
        </>
    );
};

export default ProcessTemplatePicker;
